export const EVENT_JOIN_MP = 'join-marketing-planning';
export const EVENT_LEAVE_MP = 'leave-marketing-planning';
export const EVENT_UPDATE_NODES = 'marketing-planning-update-nodes';
export const EVENT_MP_FOCUS = 'marketing-planning-focus';
export const EVENT_MP_BLUR = 'marketing-planning-blur';
export const EVENT_RELOAD_META = 'marketing-planning-reload-meta';
export const EVENT_FINALIZE_PLAN = 'marketing-planning-finalize-plan';
export const EVENT_DISCARD_PLAN = 'marketing-planning-discard-plan';
export const EVENT_DRAFT_PLAN = 'marketing-planning-draft-plan';
export const EVENT_UPDATE_METRIC_TYPES =
  'marketing-planning-update-metric-types';
export const EVENT_UPDATE_ACTIVITY_TYPES =
  'marketing-planning-update-activity-types';
export const EVENT_UPDATE_UNSAVED_CHANGES =
  'marketing-planning-update-unsaved-changes';
export const EVENT_RELOAD_NODES = 'marketing-planning-reload-nodes';
export const EVENT_CREATE_NODES = 'marketing-planning-create-nodes';
export const EVENT_DELETE_NODES = 'marketing-planning-delete-nodes';
export const EVENT_RESTORE_PLAN = 'marketing-planning-restore-plan';
export const EVENT_GO_TO_GRID = 'marketing-planning-go-to-grid';
